import { render } from "./CentersTable.vue?vue&type=template&id=735cb83e"
import script from "./CentersTable.vue?vue&type=script&lang=js"
export * from "./CentersTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__